// extracted by mini-css-extract-plugin
export default {"invite-user-modal":"InviteUserModal_invite-user-modal__jpq9q","title":"InviteUserModal_title__WKSII","description":"InviteUserModal_description__Z3fFk"};